import { makeStyles } from '@material-ui/core'

import { lightGreen, lightBlue, red } from '@material-ui/core/colors'

const styles = makeStyles((theme) => ({
  destroyTableCell: {
    backgroundColor: red[50],
  },
  justifyHeight: {
    height: '100%',
  },
  createTableCell: {
    backgroundColor: lightGreen[50],
  },
  updateTableCell: {
    backgroundColor: lightBlue[50],
  },
  noCellPadding: {
    padding: 0,
  },
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  collapseBackground: {
    backgroundColor: '#F4F6F8',
  },
}))

export default styles
